import router from '../router'
import axios from 'axios' //引入 axios
import { G } from 'core-js/modules/_export';
import { Message } from 'element-ui';
// 创建 axios 实例
const service = axios.create({
	baseURL: '', // api 的 base_url
	timeout: 60000, // 请求超时时间
})
//请求头 token 封装
service.defaults.headers.post['Content-Type'] = 'application/json';
service.interceptors.request.use(
	config => {
		if (sessionStorage.getItem('token')) {
			//token字段是要和后端协商好的
			config.headers.common["token"] = sessionStorage.getItem('token');
			// debugger
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	});

// http response 拦截器
service.interceptors.response.use(
	response => {
		if (response.data.code == 999) {
			sessionStorage.clear()
			router.replace({
				path: "/",
				query: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		if (response.data.code == 203) {
			Message.error(response.data.msg);
		}
		// }
		return response;
	},
	error => {
		return Promise.reject(error)
	}
)


export function get (url, params = {}) { //get 封装
	return new Promise((resolve, reject) => {
		service.get(url, {
			params: params
		}).then(response => {
			resolve(response.data);
		}).catch(err => {
			reject(err)
		})
	})


}

export function post (url, data = {}) { //post封装
	return new Promise((resolve, reject) => {
		service.post(url, data)
		
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

export default service
